import { Injectable } from "@angular/core";
// SignalR ***
import { HubConnection } from '@microsoft/signalr';
import { NgZone } from '@angular/core';
// SignalR ***

@Injectable({
    providedIn: "root",
})
export class SignalRService {
    userId: number;
    constructor(public _zone: NgZone) {}

    events: string[] = [
        "SignalRRefreshAppsAndWebsite",
        "SignalRRefreshRealTimeTracking",
        "SignalRShowLiveScreenshot",
        "SignalRRefreshScreenshot",
        "SignalRRefreshClient",
        "SignalRRefreshTimeTracking",
        "SignalRAgentUserStatus",
        "SignalRUserWiseTaskCreate",
        "SignalRMarkTaskAsCompleted",
        "SignalRRefreshImportData",
        "SignalRUserWiseTaskImportedFromExcel",
        "SignalRUserWiseUserImportedFromExcel",
        "SignalRUserwiseLiveScreenShotData",
        "SignalRRefreshLiveStreaming",
        "SignalRreportAllert",
        "TimesheetOverAllSummaryReport",
        "ProductivityBarReport",
        "LeaveReport",
        "SignalDateWiseNewRreportAllert",
        "SignalROutlookTaskUpdate",
        "UpdateProcess",
        "SignalRRefreshLiveStreamingScreenShot",
        "BulkUpdateManualTime",
        "SignalRallocationReport"

    ];

    // SignalR ***
    SignalRHub: HubConnection;
    isSignalRConnected = false;
    private registeredSignalRConnections = new WeakSet<object>();

    private notifyReconnectTimer: ReturnType<typeof setTimeout> | null = null;
    private notifyReconnectDelayMs = 2000;
    private readonly notifyReconnectDelayMaxMs = 60000;
    private notifyReconnectAttempts = 0;
    private readonly notifyReconnectAttemptsBeforeLongBackoff = 10;

    configureSignalRConnection(SignalRConnection): void {
        // Set the common hub
        this.SignalRHub = SignalRConnection;

        const scheduleReconnect = () => {
            if (this.notifyReconnectTimer) {
                clearTimeout(this.notifyReconnectTimer);
            }
            if (this.notifyReconnectAttempts >= this.notifyReconnectAttemptsBeforeLongBackoff) {
                abp.log.warn(
                    "ITP SignalR: many failed reconnects; backing off. Check the notify hub on the server."
                );
                this.notifyReconnectDelayMs = this.notifyReconnectDelayMaxMs;
                this.notifyReconnectAttempts = 0;
            }
            this.notifyReconnectTimer = setTimeout(() => {
                this.notifyReconnectTimer = null;
                SignalRConnection.start()
                    .then(() => {
                        this.isSignalRConnected = true;
                        this.notifyReconnectDelayMs = 2000;
                        this.notifyReconnectAttempts = 0;
                        this.sendMessage("RegisterClientId", {
                            userId: this.userId,
                            tenantId: abp.session.tenantId,
                            device: "F",
                        });
                    })
                    .catch((err) => {
                        abp.log.debug(
                            "ITP SignalR reconnect failed: " + (err && err.message ? err.message : err)
                        );
                        this.notifyReconnectAttempts++;
                        this.notifyReconnectDelayMs = Math.min(
                            this.notifyReconnectDelayMaxMs,
                            Math.max(2000, this.notifyReconnectDelayMs * 2)
                        );
                        scheduleReconnect();
                    });
            }, this.notifyReconnectDelayMs);
        };

        // Reconnect if hub disconnects (delayed + exponential backoff to avoid tight loops)
        SignalRConnection.onclose((e) => {
            this.isSignalRConnected = false;

            if (e) {
                abp.log.debug("ITP SignalR connection closed with error: " + e);
            } else {
                abp.log.debug("ITP SignalR disconnected");
            }

            this.notifyReconnectAttempts++;
            this.notifyReconnectDelayMs = Math.min(
                this.notifyReconnectDelayMaxMs,
                Math.max(2000, this.notifyReconnectDelayMs * 2)
            );
            scheduleReconnect();
        });

        //  
        // Register to get notifications
        this.registerSignalREvents(SignalRConnection);
    }

    async sendMessage(methodName: string, data: any, callback?: Function): Promise<void> {
        if (!this.isSignalRConnected) {
            if (callback) {
                callback();
            }
            abp.notify.warn("Signal R is not connected");
            return;
        }
        try {
            const result = await this.SignalRHub.invoke(methodName, data)
            if (result) {
                abp.notify.warn(result);
            }
        } catch (ex) {
            abp.log.error(ex);

            if (callback) {
                callback();
            }
        }

        if (callback) {
            callback();
        }
    }

    registerSignalREvents(signalRConnection): void {
        if (this.registeredSignalRConnections.has(signalRConnection)) {
            return;
        }

        this.registeredSignalRConnections.add(signalRConnection);

        for (let i = 0; i < this.events.length; i++) {
            const eventName = this.events[i];
            signalRConnection.on(eventName, (data) => {
                this._zone.run(() => {
                    abp.event.trigger(eventName, data);
                });
            });
        }
    }

    initSignalRConnection(objthis, eventName: string) {
        if (abp.signalr === undefined) return;
        this._zone.runOutsideAngular(() => {
            abp.signalr.connect();
            abp.signalr
                .startConnection(abp.appPath + "notify", (SignalRConnection) => {
                    this.configureSignalRConnection(SignalRConnection);
                })
                .then(() => {
                    this._zone.run(() => {
                        abp.event.trigger("SignalRRefresh");
                        this.isSignalRConnected = true;
                    });
                    this.sendMessage('RegisterClientId', {userId:this.userId,tenantId:abp.session.tenantId,device:"F"});
                });
        });
    }

    init(userId: number): void {
        this.userId = userId;
        this._zone.runOutsideAngular(() => {
            abp.signalr.connect();
            abp.signalr
                .startConnection(abp.appPath + "notify", (connection) => {
                    this.configureSignalRConnection(connection);
                })
                .then(() => {
                    this._zone.run(() => {
                        abp.event.trigger("SignalRRefresh");
                        this.isSignalRConnected = true;
                    });
                 this.sendMessage('RegisterClientId', {userId:this.userId,tenantId:abp.session.tenantId,device:"F"});
                })
        });
    }

    // SignalR ***
}
